import axios from 'axios';
import _ from 'lodash';

class ApiClient {
  constructor(baseUri, params, headers, pathToApiErrors = 'response.data.error.message') {
    this.baseUri = baseUri;
    this.headers = headers;
    this.params = params;
    this.axiosInstance = axios.create({
      baseURL: this.baseUri,
      headers: this.headers,
    });
    this.pathToApiErrors = pathToApiErrors;
  }

  get(url, params, headers, cancelToken) {
    const config = {
      headers,
      url,
      method: 'GET',
      params,
      cancelToken,
    };

    return this.request(config);
  }

  post(url, data, headers, cancelToken) {
    const config = {
      headers,
      url,
      method: 'POST',
      data,
      cancelToken,
    };

    return this.request(config);
  }

  patch(url, data, headers, cancelToken) {
    const config = {
      headers,
      url,
      method: 'PATCH',
      data,
      cancelToken,
    };

    return this.request(config);
  }

  put(url, data, headers, cancelToken) {
    const config = {
      headers,
      url,
      method: 'PUT',
      data,
      cancelToken,
    };

    return this.request(config);
  }

  delete(url, data, headers, params = {}, cancelToken) {
    const config = {
      headers,
      url,
      method: 'DELETE',
      data,
      params,
      cancelToken,
    };

    return this.request(config);
  }

  request(config) {
    const configWithHeaders = config;
    configWithHeaders.headers = _.merge(this.headers, config.headers);
    if (!config.cancelToken) {
      configWithHeaders.cancelToken = this.getCancelToken().token;
    }
    return this.axiosInstance.request(configWithHeaders)
      .catch((error) => {
        if (error.message === 'canceled') {
          return Promise.reject(error);
        }
        const errorMessage = _.get(
          error,
          this.pathToApiErrors,
          'There was problem processing your request. Please try again or adjust your parameters.',
        );
        return Promise.reject(errorMessage);
      });
  }

  // eslint-disable-next-line
  getCancelToken () {
    return axios.CancelToken.source();
  }
}

export default ApiClient;
